export default __webpack_public_path__ + "locales/lo-LA/DeleteSelfProfileDialog.json?hash=5fefdaebeaad0425a154c9b7967c3a3b";